import { ARELVARAS_CIMKE, type Arelvaras } from '../../../web/src/lib/cimkek.ts';
import { formatFt, formatMillioSav } from '../lib/formaz.ts';
import { Kartya } from '../ui/elemek.tsx';
import type { LeadSor } from './AdatokPanel.tsx';

const FORRAS_CIMKE: Record<string, string> = {
  ksh_utca: 'KSH, utcaszintű adat',
  ksh_terulet: 'KSH, területi adat',
  iroda: 'Iroda saját alapára',
};

const EMAIL_CIMKE: Record<string, string> = {
  deliverable: 'Kézbesíthető', risky: 'Kockázatos', unknown: 'Ismeretlen', nem_ellenorizve: 'Nem ellenőrizve',
};

function Sor({ cimke, ertek }: { cimke: string; ertek: string }) {
  return (
    <div className="grid grid-cols-[minmax(0,1fr)] gap-0.5 py-2 sm:grid-cols-[minmax(0,2fr)_minmax(0,3fr)] sm:gap-3">
      <dt className="text-sm text-szoveg-halk">{cimke}</dt>
      <dd className="wrap-anywhere font-medium">{ertek}</dd>
    </div>
  );
}

function utmErtek(utm: unknown, kulcs: string): string {
  if (utm && typeof utm === 'object' && !Array.isArray(utm)) {
    const v = (utm as Record<string, unknown>)[kulcs];
    if (typeof v === 'string' && v !== '') return v;
  }
  return '–';
}

export default function BecslesPanel({ lead }: { lead: LeadSor }) {
  const sav = lead.becsles_min != null && lead.becsles_max != null && !lead.szakertoi_becsles;
  return (
    <Kartya>
      <h2 className="mb-1 text-[17px] font-medium tracking-[-0.015em]">Becslés</h2>
      <p className="szam-nagy text-3xl">
        {sav ? formatMillioSav(lead.becsles_min!, lead.becsles_max!) : 'Szakértői becslés'}
      </p>
      {!sav && lead.szakertoi_ok && <p className="mt-1 wrap-anywhere text-szoveg-halk">{lead.szakertoi_ok}</p>}
      <dl className="mt-2 divide-y divide-vonal">
        {sav && lead.becsles_kozep != null && <Sor cimke="Közép" ertek={formatFt(lead.becsles_kozep)} />}
        <Sor cimke="Alapár forrása" ertek={lead.becsles_forras ? FORRAS_CIMKE[lead.becsles_forras] ?? lead.becsles_forras : '–'} />
        <Sor cimke="Motorverzió" ertek={lead.motor_verzio ?? '–'} />
        <Sor cimke="Árelvárás" ertek={lead.arelvaras ? ARELVARAS_CIMKE[lead.arelvaras as Arelvaras] ?? lead.arelvaras : 'Nem válaszolt'} />
        <Sor cimke="Lead-pontszám" ertek={String(lead.pontszam)} />
        <Sor cimke="E-mail ellenőrzése" ertek={EMAIL_CIMKE[lead.email_ellenorzes] ?? lead.email_ellenorzes} />
        <Sor cimke="Forrás" ertek={utmErtek(lead.utm, 'source')} />
        <Sor cimke="Csatorna" ertek={utmErtek(lead.utm, 'medium')} />
        <Sor cimke="Kampány" ertek={utmErtek(lead.utm, 'campaign')} />
        <Sor cimke="Google kattintásazonosító" ertek={lead.gclid ? 'van' : 'nincs'} />
        <Sor cimke="Facebook kattintásazonosító" ertek={lead.fbclid ? 'van' : 'nincs'} />
      </dl>
    </Kartya>
  );
}
